import { consts } from '../actions/registrationAction';

const initialState = {
  
  fetched: false,
  fetching: false,
  createdUserError: null,
  createdUserFetched: false,
  createdUserFetching: false,
  createdUserData: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    
    case consts.CREATE_USER_PENDING: {
      state = Object.assign({}, state, { createdUserFetching: true});
      break;
    }
    case consts.CREATE_USER_FULFILLED: {
      state = Object.assign({}, state, {createdUserFetching: false, createdUserData: action.data });
      break;
    }
    case consts.CREATE_USER_REJECTED: {
      state = Object.assign({}, state, {createdUserFetched: false, createdUserFetching: false, createdUserError: action.error.response.data});
      break;
    }
  }
  return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/registration.js